import React from 'react'

export default props => (
  <svg width="14" height="21" viewBox="0 0 14 21" fill="#A1A7C0" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 20.2969C10.866 19.2969 14 10.6454 14 6.96354C14 3.28164 10.866 0.296875 7 0.296875C3.13401 0.296875 0 3.28164 0 6.96354C0 10.6454 3.13401 19.2969 7 20.2969ZM7 10.2969C9.20914 10.2969 11 8.72987 11 6.79688C11 4.86388 9.20914 3.29688 7 3.29688C4.79086 3.29688 3 4.86388 3 6.79688C3 8.72987 4.79086 10.2969 7 10.2969Z"
    />
  </svg>
)
